import { render } from "./PViewPhotos.vue?vue&type=template&id=d19d0288"
import script from "./PViewPhotos.vue?vue&type=script&lang=js"
export * from "./PViewPhotos.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__